import React          from "react";
import styled         from "@emotion/styled";
import { graphql }    from "gatsby";
import Img            from "gatsby-image";
import { AiFillGold } from "react-icons/ai";

import LogoGoldvertrauen from "../images/altgoldankauf/logo_goldvertrauen.svg";

import HeaderImage  from "@interness/web-core/src/components/media/HeaderImage/HeaderImage";
import SEO          from "@interness/web-core/src/components/modules/SEO/SEO";
import Heading      from "@interness/web-core/src/components/text/Heading/Heading";
import Spacer       from "@interness/web-core/src/components/structure/Spacer/Spacer";
import Wrapper      from "@interness/web-core/src/components/structure/Wrapper/Wrapper";
import CallToAction from "@interness/theme-sonora/src/components/CallToAction/CallToAction";
import Accordion    from "@interness/web-core/src/components/structure/Accordion/Accordion";


const StepsContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const Step = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  align-items: flex-start;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

const StepNumber = styled.div`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d4af37, #f9d770);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
`;

const StepContent = styled.div`
  flex: 1;
`;

const StepTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 20px;
  color: #333;
`;

const StepDescription = styled.p`
  margin: 0;
  color: #666;
  line-height: 1.6;
`;

const IntroSection = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
`;

const IntroText = styled.p`
  font-size: 18px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 40px;
`;

const ItemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-top: 32px;
  text-align: left;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #f5f5f5;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
`;

const ItemIcon = styled.div`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d4af37, #f9d770);
`;

const ItemText = styled.span`
  color: #333;
  font-size: 15px;
  line-height: 1.4;
`;

const CertificationSection = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 48px 24px;
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
`;

const CertificationLogoLink = styled.a`
  display: block;
  max-width: 200px;
  margin: 0 auto 24px;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

const CertificationLogo = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const CertificationTitle = styled.h3`
  font-size: 24px;
  color: #333;
  margin: 0 0 16px 0;
  font-weight: 600;
`;

const CertificationText = styled.p`
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
`;

const faq = [

  {
    title: "Was genau ist Altgold?",
    text: "Als Altgold bezeichnet man Schmuck, Münzen oder andere Gegenstände, die einen Goldanteil enthalten, aber nicht mehr gehandelt oder getragen werden. Um den Wert zu nutzen, wird das Gold eingeschmolzen und dem Goldkreislauf wieder zugeführt – ein nachhaltiger Gedanke, der sich für Sie auch finanziell lohnt."
  },
  {
    title: "Woran erkenne ich den Goldgehalt meines Schmucks?",
    text: "Auf Schmuck, der in Deutschland verkauft wurde, befindet sich meist eine kleine Prägung – die sogenannte Punze. Sie zeigt den Goldanteil in Tausendsteln an. Häufige Werte sind: 333 (8 Karat, 33,3 % Gold), 585 (14 Karat, 58,5 % Gold – am häufigsten in Deutschland), 750 (18 Karat, 75 % Gold) und 999 (Feingold). Je höher die Zahl, desto höher der Goldanteil – und in der Regel auch der Ankaufspreis."
  },
  {
    title: "Was beeinflusst den Ankaufspreis?",
    text: "Der Preis richtet sich nach dem aktuellen Goldkurs, dem Gewicht Ihres Schmucks und dem Feingehalt (Punze). Edelsteine, Gravuren oder der künstlerische Wert des Stückes fließen in der Regel nicht in den Metallwert ein. Wenn Sie einen Stein aus einem Ring behalten möchten, lösen wir ihn gerne fachgerecht für Sie heraus."
  },
  {
    title: "Was passiert mit Steinen oder Uhrenteilen?",
    text: "Beim Ankauf wird ausschließlich der Metallwert vergütet. Edelsteine, Perlen oder Uhrwerke werden nicht mitberechnet und können auf Wunsch bei Ihnen verbleiben. Sprechen Sie uns einfach an – wir finden gemeinsam die beste Lösung."
  },
  {
    title: "Muss ich einen Termin vereinbaren?",
    text: "Nein, Sie können jederzeit während unserer Öffnungszeiten einfach vorbeikommen. Wenn Sie möchten, können Sie natürlich auch vorab anrufen – dann nehmen wir uns besonders viel Zeit für Sie."
  },
  {
    title: "Ist der Ankauf wirklich kostenlos und unverbindlich?",
    text: "Ja, absolut. Die Bewertung Ihres Schmucks ist für Sie vollständig kostenlos und unverbindlich. Sie müssen nichts verkaufen, wenn Ihnen das Angebot nicht zusagt. Versprochen."
  }
];

const AltgoldankaufPage = (props) => {
  return (
    <>
      <SEO title={"Altgoldankauf"} />
      <HeaderImage>
        <Img
          fluid={
            props.data.headerImages.images[0].file.localFile.childImageSharp
              .fluid
          }
        />
      </HeaderImage>
      <Wrapper>
        <Spacer />
        <Heading
          icon={<AiFillGold />}
          subtitle={"Fair, transparent, persönlich"}
        >
          Altgoldankauf
        </Heading>
        <IntroSection>
          <IntroText>
            Ob alter Goldschmuck im Schubfach, ein geerbtes Armband, das niemand
            mehr trägt, oder Zahngold vom Zahnarzt – bei uns sind Sie richtig.
          </IntroText>
          <ItemsGrid>
            <Item>
              <ItemIcon />
              <ItemText>Altgold und Bruchgold</ItemText>
            </Item>
            <Item>
              <ItemIcon />
              <ItemText>
                Alten oder kaputten Goldschmuck (Ringe, Ketten, Armbänder,
                Ohrringe)
              </ItemText>
            </Item>
            <Item>
              <ItemIcon />
              <ItemText>Eheringe und Verlobungsringe</ItemText>
            </Item>
            <Item>
              <ItemIcon />
              <ItemText>Goldmünzen und Goldbarren</ItemText>
            </Item>
            <Item>
              <ItemIcon />
              <ItemText>Zahngold</ItemText>
            </Item>
            <Item>
              <ItemIcon />
              <ItemText>Silberschmuck und Silberbesteck</ItemText>
            </Item>
            <Item>
              <ItemIcon />
              <ItemText>Armbanduhren mit Goldgehäuse</ItemText>
            </Item>
            <Item>
              <ItemIcon />
              <ItemText>Erbstücke und Sammlerstücke aus Gold</ItemText>
            </Item>
          </ItemsGrid>
        </IntroSection>
        <Spacer />
        <CertificationSection>
          <CertificationLogoLink
            href="https://www.gold-vertrauen.de/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <CertificationLogo
              src={LogoGoldvertrauen}
              alt="Goldvertrauen Zertifizierung"
            />
          </CertificationLogoLink>
          <CertificationTitle>Zertifizierter Fachbetrieb</CertificationTitle>
          <CertificationText>
            Juwelier Spieker ist ein zertifizierter Fachbetrieb für
            Altgoldankauf. Wir garantieren Ihnen eine professionelle,
            transparente und faire Bewertung Ihrer Goldstücke nach höchsten
            Qualitätsstandards.
          </CertificationText>
        </CertificationSection>
        <Spacer />
        <Heading>So einfach funktioniert's</Heading>
        <StepsContainer>
          <Step>
            <StepNumber>1</StepNumber>
            <StepContent>
              <StepTitle>Einfach vorbeikommen</StepTitle>
              <StepDescription>
                Kommen Sie zu uns in die Schlossstraße 15 in Hövelhof – ganz ohne Termin, wann immer es Ihnen passt.
              </StepDescription>
            </StepContent>
          </Step>
          <Step>
            <StepNumber>2</StepNumber>
            <StepContent>
              <StepTitle>Schmuck & Ausweis mitbringen</StepTitle>
              <StepDescription>
                Bringen Sie Ihren Schmuck und einen gültigen Personalausweis
                mit. Der Ausweis ist gesetzlich beim Ankauf vorgeschrieben.
              </StepDescription>
            </StepContent>
          </Step>
          <Step>
            <StepNumber>3</StepNumber>
            <StepContent>
              <StepTitle>Kostenlose Prüfung vor Ort</StepTitle>
              <StepDescription>
                Unsere Experten prüfen den Feingehalt und das Gewicht Ihrer
                Stücke direkt bei Ihnen – sorgfältig und transparent.
              </StepDescription>
            </StepContent>
          </Step>
          <Step>
            <StepNumber>4</StepNumber>
            <StepContent>
              <StepTitle>Unverbindliches Angebot erhalten</StepTitle>
              <StepDescription>
                Sie erhalten von uns ein faires Angebot auf Basis des aktuellen
                Goldkurses. Kein Druck, keine Eile – Sie entscheiden.
              </StepDescription>
            </StepContent>
          </Step>
          <Step>
            <StepNumber>5</StepNumber>
            <StepContent>
              <StepTitle>Sofort Geld erhalten</StepTitle>
              <StepDescription>
                Sind Sie einverstanden, zahlen wir sofort aus – bar oder auf
                Wunsch per Überweisung.
              </StepDescription>
            </StepContent>
          </Step>
        </StepsContainer>
        <Spacer />
        <Heading>Gut zu wissen</Heading>
        <Accordion data={faq} />
        <Spacer />
      </Wrapper>
      <CallToAction />
    </>
  );
};

export default AltgoldankaufPage;

export const query = graphql`
  query {
    headerImages: directusMediaCollection(name: { eq: "altgoldankauf" }) {
      name
      images: media {
        file {
          localFile {
            name
            childImageSharp {
              fluid(maxWidth: 1400, cropFocus: CENTER) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;
